import { render, staticRenderFns } from "./StepPayment.vue?vue&type=template&id=134b4f24&scoped=true&"
import script from "./StepPayment.vue?vue&type=script&lang=js&"
export * from "./StepPayment.vue?vue&type=script&lang=js&"
import style0 from "./StepPayment.vue?vue&type=style&index=0&id=134b4f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b4f24",
  null
  
)

export default component.exports